import api from './api';

export const leaveService = {
  // Get all leave requests
  getAllRequests: async () => {
    const response = await api.get('/leave/requests');
    return response.data;
  },

  // Get pending leave requests
  getPendingRequests: async () => {
    const response = await api.get('/leave/requests/pending');
    return response.data;
  },

  // Get leave requests by employee
  getByEmployee: async (employeeId) => {
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Employee ID is required');
    }

    const response = await api.get(`/leave/requests/employee/${employeeId}`);
    return response.data;
  },

  // Get leave request by ID
  getById: async (id) => {
    const response = await api.get(`/leave/requests/${id}`);
    return response.data;
  },

  // Create leave request
  createRequest: async (requestData) => {
    const response = await api.post('/leave/requests', requestData);
    return response.data;
  },

  // Update leave request
  updateRequest: async (id, requestData) => {
    const response = await api.put(`/leave/requests/${id}`, requestData);
    return response.data;
  },

  // Approve or reject leave request
  approveOrReject: async (id, approvalData) => {
    const response = await api.put(`/leave/requests/${id}/approval`, approvalData);
    return response.data;
  },

  // Delete leave request
  deleteRequest: async (id) => {
    await api.delete(`/leave/requests/${id}`);
  },

  // Download leave request PDF
  downloadPdf: async (id, employeeName) => {
    const response = await api.get(`/leave/requests/${id}/pdf`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    const formattedName = employeeName ? employeeName.replace(/\s+/g, '-') : `leave-request-${id}`;
    const filename = `${formattedName}-${formattedDate}.pdf`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Get calendar events. When departmentId is provided the backend scopes the
  // events to that department; existing two-argument callers are unaffected.
  getCalendarEvents: async (startDate, endDate, departmentId) => {
    let url = `/leave/calendar?startDate=${startDate}&endDate=${endDate}`;
    if (departmentId !== null && departmentId !== undefined) {
      url += `&departmentId=${departmentId}`;
    }
    const response = await api.get(url);
    return response.data;
  },

  // Get vacation availability for an employee at the end of a given month
  getVacationAvailability: async (employeeId, month, year) => {
    const response = await api.get('/leave/vacation-availability', {
      params: { employeeId, month, year },
    });
    return response.data;
  },

  // Get all leave balances for an employee
  getEmployeeBalances: async (employeeId) => {
    const response = await api.get(`/leave/balances/employee/${employeeId}`);
    return response.data;
  },

  // Adjust (manually set) a leave balance
  adjustBalance: async (data) => {
    const response = await api.put('/leave/balances/adjust', data);
    return response.data;
  },
};
